module.exports = __webpack_public_path__ + "img/btn-field-desktop.6800e8a2.png";